import { apiGet } from "./client";

export type IngestBatchSummary = {
  batchId: string;
  source: string;
  connectionId: string;
  filename?: string;
  status: string;
  counts: {
    received: number;
    accepted: number;
    rejected: number;
    lakeWritten: number;
  };
  s3Skipped?: boolean;
  error?: string;
  createdAt: string;
  completedAt?: string;
  streamEventIds?: string[];
  walk?: unknown;
};

export type IngestBatchDownloads = {
  originalUrl?: string;
  processedUrl?: string;
  exceptionsUrl?: string;
  manifestUrl?: string;
  zipUrl?: string;
};

export type IngestStreamEventSummary = {
  streamEventId: string;
  source: string;
  connectionId: string;
  receivedAt: string;
  processingStatus: string;
  batchId?: string;
  httpStatus?: number;
  path?: string;
  error?: string;
  s3Skipped?: boolean;
};

export async function listIngestBatches(opts?: {
  source?: string;
  limit?: number;
}): Promise<IngestBatchSummary[]> {
  const res = await apiGet<{ batches: IngestBatchSummary[] }>(
    "/api/ingest/batches",
    {
      source: opts?.source,
      limit: opts?.limit ?? 40,
    },
  );
  return res.batches ?? [];
}

export async function getIngestBatch(batchId: string): Promise<{
  batch: IngestBatchSummary & { s3?: Record<string, string> };
  downloads?: IngestBatchDownloads;
}> {
  return apiGet(`/api/ingest/batches/${encodeURIComponent(batchId)}`);
}

export function ingestBatchZipUrl(batchId: string): string {
  const base = import.meta.env.VITE_API_BASE_URL ?? "";
  return `${base}/api/ingest/batches/${encodeURIComponent(batchId)}/download`;
}

export async function listIngestStreams(opts?: {
  source?: string;
  day?: string;
  hour?: string;
  limit?: number;
}): Promise<IngestStreamEventSummary[]> {
  const res = await apiGet<{ events: IngestStreamEventSummary[] }>(
    "/api/ingest/streams",
    {
      source: opts?.source,
      day: opts?.day,
      hour: opts?.hour,
      limit: opts?.limit ?? 50,
    },
  );
  return res.events ?? [];
}

export async function getIngestStreamEvent(streamEventId: string): Promise<{
  event: IngestStreamEventSummary & { s3Key?: string };
  downloads?: { eventUrl?: string };
}> {
  return apiGet(`/api/ingest/streams/${encodeURIComponent(streamEventId)}`);
}

export function ingestStreamHourZipUrl(opts: {
  day: string;
  hour: string;
  source?: string;
}): string {
  const base = import.meta.env.VITE_API_BASE_URL ?? "";
  const sp = new URLSearchParams({
    day: opts.day,
    hour: opts.hour,
  });
  if (opts.source) sp.set("source", opts.source);
  return `${base}/api/ingest/streams/download?${sp.toString()}`;
}
